export default {
	description: "Click or tap any KR to make changes and view details.",
	newKRButtonText: "New key result",
};
